import { post , get , put, del} from '../axiosconfig'

import qs from 'qs';
export default {
  getToken(params) {
    return post('/zsc/web/console/user/login', params)
  },
  // 登录
  login(params) {
    return post('/api/login', params)
  },
  // 退出登录
  loginout(params) {
    return post('/zsc/web/console/user/logout', params)
  },
  // 注册
  register(params) {
    params = qs.stringify(params);
    return post('/api/v1/system/tuser/add', params)
  },
  // 获取部门列表
  getDeptlist(params) {
    params = qs.stringify(params);
    return get('/api/v1/system/dept/list', params)
  },

  // 修改用户名
  modifyName(params) {
    params = qs.stringify(params);
    return put('/api/v1/system/tuser/modifyName', params)
  },
  // 修改密码
  changePassword(params) {
    // params = qs.stringify(params);
    return post('/zsc/web/console/user/reset_password', params)
  },
  //换绑手机
  changeMoble(params) {
    return post('/zsc/web/console/user/bind_mobile', params)
  },
  // 获取二步验证秘钥
  getMFASecretKey(params) {
    params = qs.stringify(params);
    return post('/api/user/openGa', params)
  },
  // 开启二步验证
  enableMFA(params) {
    // params = qs.stringify(params);
    return post('/api/user/saveGa', params)
  },
  // 关闭二步验证
  disableMFA(params) {
    // params = qs.stringify(params);
    return post('/api/user/closeGa', params)
  },

  // 刷新令牌
  refreshToken(params) {
    params = qs.stringify(params);
    return post('/api/v1/system/tuser/refreshToken', params)
  },

  // 邮件发送
  emailSend(params) {
    params = qs.stringify(params);
    return post('/api/v1/pub/email/send', params)
  },

  // 邮件验证
  emailCheck(params) {
    params = qs.stringify(params);
    return post('/api/v1/pub/email/check', params)
  },

  // 微信绑定手机号
  setBindPhone(params) {
    return post('/zsc/web/console/user/bind_phone', params)
  },

  // 绑定手机-验证码
  sendBindPhoneSMS(params) {
    return post('/zsc/web/console/user/bind_phone_sms/send', params)
  }

}



// WEBPACK FOOTER //
// ./src/api/public/login_api.js